import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SettingsActions } from '../../../redux/Settings';
import difficulties from '../../../data/difficulty';
import BaseSelector from '../../baseSelector';

const difficultySelector = () => {
  const dispatch = useDispatch();

  const handleDifficultyChange = (data) => {
    dispatch(SettingsActions.setDifficulty(data.target.value));
  };

  const { unlockedDifficulties } = useSelector((state) => state.game);

  const options = [
    { name: 'Normal', value: difficulties.easy },
    { name: 'Nightmare', value: difficulties.normal },
    { name: 'Hell', value: difficulties.hard },
    { name: 'Inferno', value: difficulties.nightmare },
  ].filter((option) => {
    if (unlockedDifficulties.findIndex((diff) => diff === option.value) >= 0) {
      return true;
    }
    return false;
  });

  return (
    <BaseSelector
      options={options}
      label="Difficulty"
      id="difficultySelector"
      onChange={handleDifficultyChange}
    />
  );
};

export default difficultySelector;
